import { useEffect } from 'react';

import mixpanel from 'mixpanel-browser';

export function useMixPanelTrackLinks<
    TEvent extends {
        accessorId: string;
        event: string;
        eventValue: Record<string, unknown>;
    }
>(mixPanelEvent: TEvent | TEvent[]) {
    useEffect(() => {
        // prevent mixpanel from sending events in test environment
        if (process.env.NODE_ENV === 'test') {
            return;
        }
        if (Array.isArray(mixPanelEvent)) {
            return mixPanelEvent.forEach((event) => {
                mixpanel?.track_links(event.accessorId, event.event, event.eventValue);
            });
        }

        mixpanel?.track_links(
            mixPanelEvent.accessorId,
            mixPanelEvent.event,
            mixPanelEvent.eventValue
        );
    }, []);
}
